import { render } from "./BeneOnlineShop.vue?vue&type=template&id=0b7f9294&scoped=true"
import script from "./BeneOnlineShop.vue?vue&type=script&lang=js"
export * from "./BeneOnlineShop.vue?vue&type=script&lang=js"

import "./BeneOnlineShop.vue?vue&type=style&index=0&id=0b7f9294&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b7f9294"]])

export default __exports__